export default __webpack_public_path__ + "static/media/categories.16ec9d83.png";